import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { dotmapsBlue } from '@constants/colors';

import { Progress } from '@mui';

import './actions-loading-box.scss';

const LoadingBox = () => {
  const { loading } = useSelector(state => state.dashboard.resolution);
  if (loading) {
    return (
      <div styleName="loading-box-container">
        <Progress
          size={70}
          thickness={3}
          progressColor={dotmapsBlue}
        />
      </div>
    );
  }
  return null;
};

export default memo(LoadingBox);
